








import { Component, Vue } from 'vue-property-decorator';
import SocialFriends from '@/components/SocialFriends.vue';

@Component({
  components: {
    SocialFriends,
  },
})
export default class Social extends Vue {

  public data() {
    return {
    };
  }

}
